import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=48b29d85&scoped=true&"
var script = {}
import style0 from "./UserIcon.vue?vue&type=style&index=0&id=48b29d85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b29d85",
  null
  
)

export default component.exports